import { render } from "./input.md?vue&type=template&id=7d270a4c"
import script from "./input.md?vue&type=script&lang=js"
export * from "./input.md?vue&type=script&lang=js"
script.render = render

export default script